import type { FaireProductEntity } from "../../entity_types/product";

export const p_eurpanhpk9: FaireProductEntity = {
  token: "p_eurpanhpk9",
  type: "product",
  name: "Bloom Conditioner Bar – For Stronger, Softer, Healthier Hair",
  brandToken: "b_ygqtn8344d",
  brandName: "ZWS Essentials",
  imageUrl:
    "https://cdn.faire.com/fastly/add2c97cee4b3c054474bdce9cbd8dfe819e60ce80ff0908ed963d3db25c3369.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f17194267214402a311f708e89a71b20c16328a446e720a75de1646778fd96e.jpeg",
    "https://cdn.faire.com/fastly/bb0c3d5a8bf8382a5eaa32f7632921f9c3676d8d509a9d880ccc18d266226b86.jpeg",
    "https://cdn.faire.com/fastly/c93055b8d74b39254d5210acdd40a09ede9d4e7b7a88955fadeb5d8afccb9f17.jpeg",
    "https://cdn.faire.com/fastly/1fba19497d4085f34420e2664ba922f6250b9986c2bca2610f2a93629d82b0b2.jpeg",
    "https://cdn.faire.com/fastly/b47ff79f9b8a2472cf5cf6726d1c468a6c7650a0d4803009939e2b85fd7207ea.jpeg",
  ],
  priceDollars: 11.5,
  description:
    "The Bloom Conditioner Bar is rich in castor oil, rosemary, peppermint, and lavender to deeply nourish, smooth, and strengthen from root to tip. Designed to complement the Bloom Shampoo Bar, it seals in moisture, softens strands, and supports healthy hair growth—all while keeping your routine plastic-free. Nourishing, concentrated, and completely clean, it leaves your hair feeling silky, strong, and effortlessly refreshed.\n\n\n\nWhy You’ll Love It:\n\n\n\n * Locks in Moisture & Softness without heaviness \n * Strengthens & Supports Growth with castor, rosemary & peppermint oils \n * Soothes the Scalp with calming lavender \n * Detangles & Reduces Breakage for smooth, manageable hair \n * Plastic-Free & Long-Lasting—perfect for travel or everyday use \nSize: 1.",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:53.529Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
